import React from "react";

const TaskCancelledStatusIcon = () => (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="40" height="40" rx="20" fill="#BD2025" />
        <path
            d="M11.75 10.75L20 19M28.25 27.25L20 19M20 19L28.25 10.75M20 19L11.75 27.25"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default TaskCancelledStatusIcon;
